import { useParams as wouterUseParams } from "wouter-preact";

export function useParams(): {
    get: (key: string) => string;
    opt: (key: string) => string | undefined;
} {
    const params = wouterUseParams();

    const getOptional = (key: string): string | undefined => {
        const value = params[key];
        return value != null && value !== ""
            ? decodeURIComponent(value)
            : undefined;
    };

    return {
        get: (key: string): string => {
            const value = getOptional(key);
            if (value == null) {
                throw new Error(`Missing required URL param: ${key}`);
            }
            return value;
        },
        opt: getOptional,
    };
}
